export default "__VITE_ASSET__DX$cSBsz__"